export const state = () => ({
	interviews: null,
	interview: null,
	reschedule: false,
	cursor: null,
	search: null,
	filters: null,
	show_filters: false,
});

export const mutations = {
	setInterviews(state: any, payload: any) {
		state.interviews = payload;
	},
	setInterview(state: any, payload: any) {
		state.interview = payload;
	},
	setReschedule(state: any, payload: any) {
		state.reschedule = payload;
	},
	setCursor(state: any, payload: any) {
		state.cursor = payload;
	},
	setSearch(state: any, payload: any) {
		state.search = payload;
	},
	setFilters(state: any, payload: any) {
		state.filters = payload;
	},
	setShowFilters(state: any, payload: any) {
		state.show_filters = payload;
	},
};

export const getters = {
	getInterviews: (state: any) => state.interviews,
	getInterview: (state: any) => state.interview,
	getReschedule: (state: any) => state.reschedule,
	getCursor: (state: any) => state.cursor,
	getSearch: (state: any) => state.search,
	getFilters: (state: any) => state.filters,
	getShowFilters: (state: any) => state.show_filters,
};

export const actions = {
	async fetchCandidateInterviews(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			let params = {
				search: state.state.search,
				interview_type: state.state.filters?.interview_type?.value,
				status: state.state.filters?.status?.value,
				from_date: state.state.filters?.from_date,
				to_date: state.state.filters?.to_date,
				cursor: state.state.cursor,
			};

			Object.keys(params).forEach((key) => !params[key] && delete params[key]);

			this.$axios
				.get('/api/interviews', { params })
				.then((res) => {
					let interviews;

					if (state.state.interviews) {
						interviews = JSON.parse(
							JSON.stringify(state.state.interviews),
						);
					}

					if (params.cursor) {
						interviews.data.push(...res.data.data);
						interviews.links = res.data.links;
						interviews.meta = res.data.meta;
					} else {
						interviews = res.data;
					}

					state.commit('setInterviews', interviews);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	getInterview(state: any, interview_uuid: string) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get(`/api/interviews/${interview_uuid}`)
				.then((res) => {
					state.commit('setInterview', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	respondToInterview(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/interviews/' + payload.uuid, payload.data)
				.then((res) => {
					state.commit('setInterview', res.data);
					resolve(res.status);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	getInterviewCalendarDays(state: any, payload: object) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/interviews/calendar', { params: payload })
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateInterviews(state: any, payload: any) {
		state.commit('setInterviews', payload);
	},

	updateInterview(state: any, payload: any) {
		state.commit('setInterview', payload);
	},

	updateReschedule(state: any, payload: any) {
		state.commit('setReschedule', payload);
	},

	setCursor(state: any, payload: any) {
		state.commit('setCursor', payload);
	},

	setSearch(state: any, payload: any) {
		state.commit('setSearch', payload);
	},

	setFilters(state: any, payload: any) {
		state.commit('setFilters', payload);
	},

	setShowFilters(state: any, payload: any) {
		state.commit('setShowFilters', payload);
	},
};
